import { FileActionModal, type FileActionPrefill } from "@/components/mirror/FileActionModal";
import { FEATURE_FLAGS } from "@/config/featureFlags";
import { mirrorFileWriteCurrentRequest } from "../../../../supabase/functions/_shared/mirrorFileWriteIntent";
import type { ModuleCaptureHandler } from "@/lib/capture/types";

const str = (value: unknown, max: number) => typeof value === "string" ? value.trim().slice(0, max) : "";
export const fileCaptureHandler: ModuleCaptureHandler<FileActionPrefill> = {
  tool: "propose_file_action",
  isEnabled: () => FEATURE_FLAGS.FILES_EXECUTOR_ENABLED,
  getRawText: proposal => {
    if (proposal.tool !== "propose_file_action") return "";
    const args = proposal.args;
    return typeof args.raw_text === "string" ? args.raw_text : [args.action, args.provider ?? "auto", args.query ?? "", args.name ?? "", args.content_text ?? ""].join("|").trim();
  },
  extract: async (_rawText, proposal, ctx) => {
    if (proposal.tool !== "propose_file_action") return null;
    const args = proposal.args as unknown as Record<string, unknown>;
    if (args.action === "search") return {
      action: "search", provider: ["google_drive", "onedrive", "notion", "dropbox"].includes(String(args.provider)) ? args.provider as FileActionPrefill["provider"] : "auto",
      query: str(args.query, 300), name: "", content_text: "", action_id: proposal.action_id,
    };
    if (!ctx.ownerId || !ctx.sessionId || typeof args.raw_text !== "string" || args.raw_text !== ctx.latestUserText) return null;
    ctx.assertCurrent?.();
    const expected = mirrorFileWriteCurrentRequest(args.raw_text);
    if (!expected || Object.entries(expected).some(([key, value]) => args[key] !== value)) return null;
    return { ...expected, action_id: proposal.action_id, expected_user_id: ctx.ownerId, expected_session_id: ctx.sessionId };
  },
  renderModal: ({ open, prefill, isCurrent, onClose, onCreated }) => (
    <FileActionModal open={open} prefill={prefill} isCurrent={isCurrent} onClose={onClose} onCreated={onCreated} />
  ),
};
